import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';

import {
  getContainerDefaults,
  getContainerPropsConfig,
  getContainerSlotDefaults,
  getContainerSlotPropsConfig,
  getIoConfig,
} from './_base-container.element';
import { CONTAINER_DEFAULT_HEIGHT, CONTAINER_INITIAL_SLOT_ID } from './_container.models';
import { ContainerDefinitionMapper } from './ai/container.definition-mapper';
import { ContainerElementHandler } from './ai/container.element-handler';
import { ContainerComponent } from './container.component';

export function getContainerDefinition(): CanvasElementDefinition<'container'> {
  return {
    type: 'container',
    componentType: ContainerComponent,
    isListed: true,
    name: 'Container',
    groups: ['containers'],
    width: { mode: 'full' },
    // By default the element should have a min-height and grow automatically if needed
    height: { mode: 'value', fixed: false, value: CONTAINER_DEFAULT_HEIGHT },
    slots: {
      ids: [CONTAINER_INITIAL_SLOT_ID],
      [CONTAINER_INITIAL_SLOT_ID]: {
        children: [],
      },
    },
    ioConfig: getIoConfig(),
    propsConfig: getContainerPropsConfig(),
    slotPropsConfig: getContainerSlotPropsConfig,
    defaults: getContainerDefaults(),
    slotDefaults: getContainerSlotDefaults(),
    styleIncludePaths: ['style'],
    features: {
      resizeWithChild: true,
    },
    ai: {
      name: 'row',
      handler: () => ContainerElementHandler,
      definitionMapper: () => ContainerDefinitionMapper,
    },
    version: 1,
  };
}
